"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoxStyled = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _nikeDesignSystemComponents = require("@nike/nike-design-system-components");

var _templateObject;

var BoxStyled = (0, _styled.default)(_nikeDesignSystemComponents.Box)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: flex-start;\n  padding: 12px 12px;\n  width: 100%;\n"])));
exports.BoxStyled = BoxStyled;